export const en = {
    // MobileNo Screen
    header_title: "All India Institute of Medical Sciences, Bhopal",
    header_subtitle: "Orocancer Watch",
    header_small: "Sponscerd by",
    header_mpct: "Madhya Pradesh Council of Science and Technology",
    get_started: "Enter Mobile Number",
    enter_phone: "An OTP will be sent to the entered number",
    mobile_label: "Mob No.",
    continue_btn: "Continue",
    welcome_title: "Welcome to Doctor App",
    welcome_text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    language_label: "Language",

    // Chatbox
    chatbox_title: "Chatbox",
    back_btn: "Back",
    reset_btn: "Reset",
    history_title: "History Conversion", // Note: The original generic text says "History Conversion", likely meant "Conversation History" but keeping as is or correcting to "History"
    history_text: "Lorem Ipsum is simply dummy text...", // Leaving dummy text as is for now

    // Questions
    b_Continue:'Continue',
    q_hii:"Hi",
    q_namaskar:"please click continue to start the diagnoistic process.",


    follow_up_template_smoking_duration:"How long have you smoked ${item}?",
    follow_up_template_smoking_frequency:"How often do you smoke ${item}?",


    
    q_smoke: "Do you smoke?",
    q_smoke_type: "What type of smoking do you do?",
    opt_cigarette: "Cigarette",
    opt_bidi: "Bidi",
    opt_cigar: "Cigar",
    opt_hookah: "Hookah",
    q_smoke_duration: "Smoking duration",
    q_smoke_freq: "Smoking frequency",
    opt_occ: "Occasionally (less than once daily)",
    opt_1_5: "1–5 times/day",
    opt_6_10: "6–10 times/day",
    opt_10_plus: "More than 10 times/day",
    opt_smoke_dur1:"Less than 1 year",
    opt_smoke_dur2:"1-5 year",
    opt_smoke_dur3:"More than 5 year",
    q_chew: "Do you chew areca nut / betel nut / gutkha / pan masala?",
    q_chew_duration: "chew Duration",
    q_chew_freq: "chew frequency",

    q_alcohol: "Do you consume alcohol?",
    q_alcohol_duration: "alcohol Duration",
    q_alcohol_freq: "alcohol frequency", // reusing logic if needed, or specific key

    q_symptoms: "Which symptoms are you experiencing (Select all which are applicable)",
    // ... adding truncated list for brevity in this step, logically I should add all options.
    // For this demo/task, I will add the main question text first to demonstrate working.

    q_location: "Location of the Mouth Problem (Select all which are applicable)",
    q_side: "Side involved",
    opt_right: "Right",
    opt_left: "Left",
    opt_both: "Both",

    q_upload_photo: "upload a clear photo of the mouth area showing the problem",
    q_result: "Please Click the button below to check result",

    // Disclaimer
    terms_title: "Informed Consant",
    terms_text: "I am voluntarily using this mobile application to check for possible problems inside my mouth, such as sores, white or red patches, lumps, swelling, ulcers, non-healing wounds, difficulty opening the mouth, or other unusual changes.",
    terms_text1: "I understand that this application is only a screening tool and does not provide a final diagnosis or treatment.",
    terms_text2: "I agree to answer all questions honestly and allow photographs of my mouth to be taken and analyzed through the application.",
    terms_text3: "I give permission for my photographs and information to be used for education, research, academic publications, improving the application, and helping guide further care.",
    terms_text4: "I understand that my identity will be kept confidential and will not be revealed in any publication or educational material.",
    terms_text5: "I understand that I may stop using the application at any time without affecting my medical or dental care.",
    agree_terms: "By selecting 'I Agree', I confirm that I have read and understood the above information and voluntarily provide my consent.",
    start_chat: "Next",

    //terms//
    t_cond_text: "Terms and Conditions",
    t_cond_text1:"1.Medical Disclaimer & Limitation of Services:",
    t_cond_text_1:"The [Orocancer Watch] screening tool is designed to identify risk factors associated with Oral Potentially Malignant Disorders (OPMD) and is not a definitive diagnostic device. All results generated are indicative; a 'Low Risk' result does not rule out the presence of disease, and a 'High Risk' result does not confirm malignancy. Users are strictly advised to consult a dental surgeon or oncologist",
    t_cond_text2:"2. Nature of Screening ",
    t_cond_text_2:"The screening provided by this application is a non-invasive, preliminary risk assessment based on photographic evidence and user-reported habits. It is intended to identify oral mucosal abnormalities that may be associated with an increased risk of oral cancer. Users must understand that this digital screening does not constitute a biopsy or a definitive medical diagnosis. A 'Low Risk' result is not a guarantee of health, and a 'High Risk' result is not a confirmation of cancer",
    t_cond_text3:"3. Data Privacy & Consent (DPDP Act Compliance)",
    t_cond_text_3:"By using this application, you provide your clear and affirmative consent for us to collect and process your personal and sensitive health data, including photographs of oral lesions, for the sole purpose of oral health screening and risk assessment. This data may also be used to improve our screening algorithm to ensure the app remains a trusted, evidence-based digital resource for the community. You have the right to withdraw your consent at any time; however, please understand that withdrawing consent will result in our inability to provide you with a screening result or further assessment. All data collection and use are intended to promote early detection and informed decision-making through accurate, patient-friendly information",
    t_cond_text4:"4. User Responsibilities",
    t_cond_text_4:"As a user of this application, you are responsible for providing accurate and complete information regarding your medical history, tobacco or betel nut usage, and other health habits to ensure a valid risk assessment. When using the screening tool, you must ensure that any photographs of the oral cavity are clear, well-lit, and capture the area of concern as instructed, as poor-quality data may lead to inaccurate results",
    t_cond_text5:"5. Intellectual Property",
    t_cond_text_5:"All content, features, and functionality of this application—including but not limited to the screening algorithms, risk assessment logic, software code, user interface designs, and educational materials—are the exclusive intellectual property of the developers. This application is provided as an evidence-based digital resource for community health awareness, and users are granted a limited, non-transferable license for personal, non-commercial use only. You may not copy, modify, reverse-engineer, or distribute any part of the application’s technology or proprietary screening methods without prior written consent.",
    t_cond_text6:"6. Limitation of Liability",
    t_cond_text_6:"The developers are not liable for any health outcomes or damages resulting from the use of this screening tool. This app is a 'triage' resource for early detection, not a clinical diagnosis; we are not responsible for assessment inaccuracies or technical errors. By using this application, you acknowledge that final clinical responsibility rests with a qualified healthcare provider after a physical examination",
    t_cond_text7:"Grievance Redressal",
    t_cond_text_7:"• Grievance Officer: Under Indian law (IT Rules 2011), you must provide the name and contact details of a Grievance Officer who users can contact regarding data or service issues.",
    t_cond_text_7_7:"if you have any concerns regarding your data privacy or the services provided, please contact our Grievance Officer, [Name], at [Email Address]. We commit to acknowledging your grievance within 48 hours and resolving it within 30 days.",
    // pateints form
    p_title:"Personal Details",
    p_mob:"Mobile Number",
    p_name:"Full Name",
    p_dob:"Date of Birth",
    p_gender:"Gender",
    p_age:"Age",
    p_village:"Village",
    p_district:"District",
    p_male:"Male",
    p_female:"Female",
    p_other:"Other",
   p_address:"Address",
    // About
    about_title: "About Us",
    a_title1: "Introduction",
    a_para1: "This mobile application is an innovative digital health initiative developed by doctors and researchers from the All India Institute of Medical Sciences Bhopal to support the early detection of Oral Potentially Malignant Disorders (OPMDs) and oral cancer.",
    list1: "OPMDs are conditions in the mouth that have a higher risk of turning into cancer if they are not detected and treated early. In countries like India, where tobacco and related habits are common, oral cancer remains a major public health concern. Early identification of these conditions can significantly improve treatment outcomes and reduce mortality.",
    list2: "This application aims to bridge the gap between advanced medical screening and the general public by providing a simple, accessible, and technology-driven solution through smartphones.",
    a_title2: "Purpose of the Application:",
    a_para3: "The primary goal of this application is to assist in the early screening and detection of oral potentially malignant disorders using mobile technology.",
    a_subtitle2:"The application is designed to:",
    list3:"Promote early detection of oral cancer and precancerous conditions",
    list4:"Assist healthcare workers and doctors in screening patients quickly",
    list5:"Provide instant risk assessment and preliminary guidance",
    list6:"Increase public awareness about oral health and harmful habits ",
    list7:"Support research and data collection for better oral cancer prevention policies",
    listp8:"Through this platform, individuals can be screened easily and referred for further medical evaluation when required.",
    a_title3: "How the Application Works",
    a_para4:"The mobile application uses a user-friendly interface and intelligent algorithms to help detect symptoms related to oral diseases.",
    a_subtitle3:"Key steps include:",
    para4_list1:"User Registration",
    para4_listp1:"Users or healthcare workers register basic information such as age, gender, medical history, and lifestyle habits (tobacco use, alcohol consumption, etc.).",
    para4_list2:"Oral Examination Input",
    para4_listp2:"The user or health worker can upload images or provide clinical details related to the oral cavity.",
    para4_list3:"Automated Analysis",
    para4_listp3:"The system evaluates the input data to identify possible signs of:",
    para4_sublist3:"Oral potentially malignant disorders (OPMDs)",
    para4_sublist31:"Oral cancer risk indicators",
    para4_sublist32:"Restricted mouth opening and other oral health conditions.",
    para4_list4:"Instant Results and Guidance",
    para4_listp4:"The application generates preliminary screening results within minutes and suggests whether the user should consult a medical professional for further evaluation.",
    a_title4: "How This App Helps the Public",
    a_para5:"This application provides several benefits for the community:",
    para5_list1:"Early Detection of Oral Cancer",
    para5_listp1:"By identifying symptoms at an early stage, the app helps individuals seek medical attention before the disease progresses.",
    para5_list2:"Easy Access to Screening",
    para5_listp2:"People in rural and remote areas often lack access to specialized healthcare. A smartphone-based screening tool allows anyone to perform a basic preliminary check.",
    para5_list3:"Awareness and Education",
    para5_listp3:"The app educates users about:",
    para5_listp31:"Risks of tobacco and betel nut consumption",
    para5_listp32:"Warning signs of oral diseases",
    para5_listp33:"Preventive oral health practices.",
    para5_list4:"Faster Medical Referral",
    para5_listp4:"If suspicious signs are detected, the application can recommend consultation with dentists or specialists, enabling timely diagnosis and treatment.",
    para5_list5:"Support for Public Health Programs",
    para5_listp5:"The data collected through the application can help healthcare authorities understand disease patterns and design better oral cancer prevention programs.",
    a_title6:"Research and Development",
    a_para6:"The development of this application is part of a research initiative supported by the Madhya Pradesh Council of Science and Technology, aimed at creating innovative tools for the early detection of oral cancer.",
    a_para61:"The project is led by a multidisciplinary team of specialists including oral surgeons, oncologists, pathologists, and public health experts from All India Institute of Medical Sciences Bhopal.",
     a_title7:"Vision",
    a_para7:"Our vision is to create a technology-enabled healthcare ecosystem where early detection, awareness, and preventive care help reduce the burden of oral cancer and improve overall community health.",
    a_title8:"Mission",
    para_8_list1:"To make oral cancer screening accessible, affordable, and scalable",
    para_8_list2:"To empower healthcare workers with digital diagnostic tools",
    para_8_list3:"To promote preventive healthcare and awareness",
    para_8_list4:"To contribute to research-driven public health solutions",
    para_9:"Project Investigators",
    para_list91:"Dr. Anshul Rai",
    para_list911:"Oral & Maxillofacial Surgery, All India Institute Of Medical Sciences Saket Nagar, Bhopal, M.P. -462020",
    para_list92:"Co-P I: Dr Saikat Das ",
    para_list922:"Dept.Radiation Oncology Dept, All India Institute Of Medical Sciences Saket Nagar, Bhopal, M.P. - 462020",
    para_list93:"Co-PI:Abhinav Singh",
    para_list933:"Professor All India Institute Of Medical Sciences Saket Nagar, Bhopal, M.P.- 462020",
    para_list94:"Co-P I: Dr Deepti Joshi",
    para_list944:"Dept. Of Pathology All India Institute Of Medical Sciences Saket Nagar, Bhopal, M.P. - 462020",
    para_list95:"Co-P I:Dr Ankur Joshi",
    para_list955:"Asst prof , Community & family medicine , All India Institute Of Medical Sciences Saket Nagar, Bhopal, M.P. - 462020",
        // OTP
    verify_details: "Verify Your Details",
    enter_otp: "Enter Otp",
    otpSent:"Enter the OTP sent to",
    verify_otp_btn: "Verify OTP",
    otp_side_title: "OTP",

    // Privacy
    privacy_title: "Privacy Policy",
    privacy_text: "This Privacy Policy explains how [App Name]  collects, uses, stores, and protects information obtained from users during screening for Oral Potentially Malignant Disorders (OPMDs) and Oral Cancer. The App is developed for screening, awareness, early detection, and research purposes and does not replace professional medical diagnosis or treatment.",


    // Result
    report_title: "Report",
    report_text: "There are many variations of passages of Lorem Ipsum available...", // Dummy
    result_title: "ORAL CANCER SCREENING: PROVISIONAL REPORT",

    // Chatsms UI
    btn_submit: "Submit",
    btn_yes: "Yes",
    btn_no: "No",
    btn_check_results: "Check Results",
    msg_file_selected: "File Selected",
    msg_choose_file: "Choose File",
    msg_image_selected: "Image Selected",
    msg_choose_image: "Choose Image",
    msg_add_image: "Add image",

    // Symptoms
    sym_none:"None",
    sym_burning: "Burning sensation in the mouth, while rest / eating spicy food",
    sym_pain: "Pain or soreness in the mouth",
    sym_ulcers: "Mouth ulcers that persist more than 14 days",
    sym_white: "Whitish discolouration in the mouth",
    sym_red: "Reddish discolouration in the mouth",
    sym_mixed: "Mixed red and white discolouration in the mouth",
    sym_thick: "Thickened or hardened area in the mouth",
    sym_open_diff: "Difficulty in opening the mouth",
    sym_chew_diff: "Difficulty in chewing food",
    sym_swallow_diff: "Difficulty in swallowing food",
    sym_dec_open: "Decreased mouth opening compared to earlier",
    sym_stiff: "Tightness or stiffness in the oral cavity",
    sym_dry: "Dryness in the mouth",
    sym_taste: "Altered taste sensation",
    sym_bleed: "Bleeding from ulcer",
    sym_loose: "Loosened tooth",
    sym_irritation: "Sharp edge of tooth causing irritation",

    // Location Options
    opt_inside_cheek: "Inside of cheek",
    opt_Center_tongue: "Center of the Tongue",
    opt_Front_tongue: "Front of the Tongue",
    opt_Side_tongue: "Side of the Tongue", 
    opt_below_tongue: "Below the tongue",
    opt_Lower_gums: "Lower Gum",
    opt_Upper_gums: "Upper Gum",
    opt_backside_gums: "Backside of Upper & Lower Gum",
    opt_roof_mouth: "Roof of mouth",
    opt_lips: "Lips",
    opt_lower_lips: "Inner Lower Lip",
    opt_upper_lips: "Inner Upper Lip",
      //  Awerness
       aw_title:"Awareness",
       aw_t_one:"Early Signs of Tobacco-Related Oral Damage",
       aw_sb_one:"A Silent Threat Inside Your Mouth",
       aw_p_one:"Placing tobacco pouches in the mouth causes chemical burns, tooth decay, and permanent gum damage. Long-term use may result in precancerous lesions and oral cancer. Regular dental check-ups and quitting tobacco are essential for oral health. White patches, ulcers, gum injury, and tooth damage are early signs of tobacco pouch abuse. Early detection and immediate cessation can prevent serious complications, including oral cancer.",
       aw_t_two :"Tobacco-Related Oral Lesion",
       aw_sb_two:"Early Warning Signs Should Never Be Ignored",
       aw_p_two:"This image highlights abnormal tissue changes inside the mouth, commonly associated with long-term tobacco use. Such lesions may begin painlessly but can progress into serious oral diseases if left untreated. Early examination, biopsy when advised, and immediate tobacco cessation are critical for oral and overall health. ",
       aw_t_three:"Abnormal Oral Tissue Changes Detected",
       aw_sb_three:"Early Signs Should Never Be Ignored",
       aw_p_three:"This image highlights tissue injury and inflammation inside the mouth identified during a dental examination.Such changes may result from tobacco use, chronic irritation, sharp teeth, or poor oral hygiene. Any non-healing sore, redness, or bleeding area should be examined promptly by a dental professional. ", 
    // Footer
    footer_home: "Home",
    footer_about: "About",
    footer_more: "More",
};
